export function EditorPermissionsDescription() {
  return (
    <>
      Manage matter files and <strong className="font-bold text-brand-800">records*</strong>, view any chat, and edit any{' '}
      <strong className="font-bold text-brand-800">draft*</strong> or <strong className="font-bold text-brand-800">table*</strong>.
    </>
  )
}
